export const GhostLogo = ({ size = 36 }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" aria-label="GHOSTCODE logo">
    <path d="M50 8C31 8 19 24 19 46v40l10.5-7 10.5 7 10-7 10 7 10.5-7L81 86V46C81 24 69 8 50 8z" fill="#080A0C" stroke="#00FF66" strokeWidth="5" strokeLinejoin="round" />
    <circle cx="38" cy="42" r="5" fill="#00FF66" className="gc-eye" />
    <circle cx="62" cy="42" r="5" fill="#00FF66" className="gc-eye" />
    <path d="M40 58l-8 7 8 7M60 58l8 7-8 7" stroke="#00FF66" strokeWidth="4.5" strokeLinecap="round" strokeLinejoin="round" fill="none" />
  </svg>
);

export const Wordmark = ({ size = 32 }) => (
  <span className="flex items-center gap-2.5">
    <GhostLogo size={size} />
    <span className="font-display font-bold tracking-widest text-white" style={{ fontSize: size * 0.52 }}>
      GHOST<span className="text-[#00FF66]">CODE</span>
    </span>
  </span>
);
